/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import PageScaffold from '../../components/app/page-scaffold'
import {BaseLayout} from '../../components/layout'
import {routes} from '../../utils/config'
import {RoleSelector} from '../role-selector'

import {Accordion, Panel} from 'baseui/accordion'
import {Block} from 'baseui/block'
import {Button} from 'baseui/button'
import {Card} from 'baseui/card'
import {ParagraphSmall} from 'baseui/typography'
import {format} from 'date-fns'
import {useSelector} from 'react-redux'
import {formatPrice} from '../../utils/helpers'
import CenteredBlock from '../../components/app/centered-block'
import RowBlock from '../../components/app/row-block'
import {BackButton} from '../../components/app'

const Credits = () => {
  return (
    <RowBlock>
      <BackButton />
      <PageScaffold pageTitle={routes.credits.name}>
        <Block
          overrides={{
            Block: {
              style: ({$theme}) => ({
                marginBottom: $theme.sizing.scale800,
                maxWidth: '60rem',
              }),
            },
          }}
        >
          <Card title="This is the credit title which should be centered when you put in the credits">
            Heres some dummy text
          </Card>
        </Block>
      </PageScaffold>
    </RowBlock>
  )
}

export default Credits
